module.exports = __webpack_public_path__ + "media/music/da1a6ebcd442e9d867b31fb21ce6a289.mp3";